import { plugins as BaseEditorPlugins } from './EditorPlugins'
import makeLinkPlugin from './link'
import makeMentionPlugin from './mention'
import makeNoteLinkPlugin from './NoteLinkInAppPlugin'

import CommentSubmitPlugin from './CommentSubmitPlugin'

export default async ({
  submit = x => x,
  cancel = x => x,
  getFullNotePath,
  getCurrentUser,
  fetchUsers,
  fetchNotes,
  hasEditorNextFeatureFlag = false,
}) => {
  const SliteEditorPlugins = hasEditorNextFeatureFlag
    ? (await import(/* webpackChunkName: "editor-next" */ './EditorNextPlugins'))
        .plugins
    : BaseEditorPlugins

  return Promise.all([
    SliteEditorPlugins.CorePlugin(),
    makeMentionPlugin({ MentionPlugin: SliteEditorPlugins.MentionPlugin })(),
    makeNoteLinkPlugin({ NoteLinkPlugin: SliteEditorPlugins.NoteLinkPlugin })(),
    SliteEditorPlugins.MentionPickerPlugin({
      getCurrentUser,
      fetchUsers,
      fetchNotes,
    }),
    SliteEditorPlugins.EmojiPickerPlugin(),
    makeLinkPlugin({ LinkPlugin: SliteEditorPlugins.LinkPlugin })(),
    CommentSubmitPlugin({ submit, cancel }),
    SliteEditorPlugins.ClipboardPlugin({ getFullNotePath }),
  ])
}
